<template>
  <div class="home py-5">
    <span class="d-flex flex-row page-title">{{$t("intranet.title.page.wineOfTheMonth.create")}}</span>
    <div v-if="dataLoaded" class="form-container">
      <AveineWineOfTheMonthForm :wineOfTheMonth="wineOfTheMonth" :APIbaseURL="APIbaseURL" />
    </div>
    <div v-else class="d-flex justify-center align-center mt-16">
      <v-progress-circular indeterminate :size="100" :width="10" color="secondary"></v-progress-circular>
    </div>
  </div>
</template>

<script>
import AveineWineOfTheMonthForm from '@/components/AveineWineOfTheMonthForm.vue'
import WineOfTheMonth from '@/store/models/wine-of-the-month'

export default {
  name: 'Create',
  components: { AveineWineOfTheMonthForm },
  data () {
    return {
      wineOfTheMonth: {},
      dataLoaded: false,
      APIbaseURL: process.env.VUE_APP_API_HOST
    }
  },
  async created () {
    // `Model.new()` donne un id en `$uid`, converti en `lid` a la
    // serialisation : sans lui le serialiseur plante sur `data.id.charAt()`.
    this.wineOfTheMonth = await WineOfTheMonth.new()
    this.wineOfTheMonth.$isNew = true
    this.wineOfTheMonth.description = {}
    this.wineOfTheMonth.tags = []
    this.dataLoaded = true
  }
}
</script>
